import { isValidElement } from 'react';
export function canClone(arg) {
    return isValidElement(arg);
}
//# sourceMappingURL=canClone.js.map